<template>
  <div class="step-information">
    <div v-if="isLoading" class="loading-spinner">
      <h3>{{ props.stepData.loadingTitle }}</h3>
      <LoadingSpinner v-if="!hideSpinner" />
      <svg v-else class="check" viewBox="0 0 79 58" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M2.585 32.597 25.55 54.143l50.035-51"
          stroke="#74B939"
          fill="none"
          fill-rule="evenodd"
          stroke-linecap="round"
        />
      </svg>
      <p>Bitte haben Sie einen Moment Geduld.</p>
    </div>

    <div v-else class="results-found">
      <svg class="check" viewBox="0 0 79 58" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M2.585 32.597 25.55 54.143l50.035-51"
          stroke="#74B939"
          fill="none"
          fill-rule="evenodd"
          stroke-linecap="round"
        />
      </svg>
      <h3 v-if="props.stepData.title">
        {{ props.stepData.title }}
      </h3>
      <article>
        <WizcoRichtextResolver v-if="props.stepData.content" :blok="props.stepData.content" />
        <header>
          <h4>{{ props.stepData.listTitle }}</h4>
        </header>
        <ol>
          <li v-for="listItem in props.stepData.listPoints" :key="listItem._uid">
            <p>{{ listItem.content }}</p>
          </li>
        </ol>
      </article>
    </div>
    <StepFooter @click="wizco.submit()" />
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import LoadingSpinner from '../components/LoadingSpinner.vue'
import StepFooter from '../components/footer/StepFooter.vue'
import { useWizcoStore } from '../stores/wizco'

const props = defineProps({
  stepData: {
    type: Object,
    required: true
  }
})

const wizco = useWizcoStore()
const isLoading = ref(true)
const hideSpinner = ref(false)

onMounted(() => {
  if (Number(props.stepData.loadingTime) && Number(props.stepData.loadingTime) > 0) {
    setTimeout(
      () => {
        hideSpinner.value = true
      },
      (Number(props.stepData.loadingTime) - 1) * 1000
    )

    setTimeout(
      () => {
        isLoading.value = false
        wizco.isActiveStepReady = true
      },
      Number(props.stepData.loadingTime) * 1000
    )
  } else {
    hideSpinner.value = true
    isLoading.value = false
  }
})
</script>

<style>
.step-information :is(h3, h4) {
  font-size: 18px;
  line-height: 1.44;
  color: var(--neutral80);
}

.step-information svg.check {
  stroke-dasharray: 120;
  stroke-dashoffset: 120;
  stroke-width: 7px;
  height: 30px;
  width: auto;
  margin-top: 20px;
}

.step-information .loading-spinner {
  text-align: center;
}

.step-information .loading-spinner h3 {
  font-weight: 300;
  max-width: 200px;
  margin: 0 auto 34px;
  text-align: center;
}

.step-information .loading-spinner svg.check {
  width: 82px;
  height: auto;
  font-size: 82px;
  line-height: 82px;
  margin-bottom: 34px;
  animation: wk-draw calc(var(--time2) * 2) ease-in-out var(--time2) forwards;
}

.step-information .loading-spinner p {
  font-size: 18px;
  font-weight: 700;
  max-width: 400px;
  margin: 0 auto 34px;
  background-color: #fff;
  color: var(--neutral80);
  padding: 27px;
  display: none;
}

.step-information .results-found {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
}

.step-information .results-found h3 {
  font-weight: 700;
  padding-inline: 10px;
  text-align: center;
}

.step-information .results-found svg.check {
  stroke-dashoffset: 0;
}

.step-information .results-found article {
  margin: 10px calc(var(--padding-inline) * -1) -69px;
  padding: var(--padding-inline);
  padding-bottom: 0;
  background-color: #fff;
}

.step-information .results-found article header > * {
  text-align: left;
  padding-inline: 0;
  font-weight: 700;
  font-size: 18px;
}

.step-information .results-found article ol {
  padding: 10px 0 10px 40px;
  margin-left: 0;
}

.step-information .results-found article ol > li {
  margin-bottom: 15px;
  font-size: 18px;
  color: var(--neutral80);
  line-height: 1.44;
}

.step-information .results-found article ol > li::marker {
  font-size: 40px;
  font-weight: 700;
  line-height: 0.65;
  color: #b3ceda;
  padding-right: 15px;
}

@keyframes wk-draw {
  100% {
    stroke-dashoffset: 0;
  }
}

@media (min-width: 576px) {
  .step-information :is(h3, h4) {
    font-size: 22px;
    line-height: 1.36;
  }

  .step-information svg.check {
    height: 55px;
    stroke-width: 5px;
  }

  .step-information .loading-spinner h3 {
    width: 230px;
  }

  .step-information .loading-spinner p {
    display: block;
  }

  .step-information .results-found {
    max-width: 450px;
    margin-inline: auto;
  }

  .step-information .results-found article {
    margin: 10px auto 0;
    padding-bottom: var(--padding-inline);
  }

  .step-information .results-found article ol {
    padding-bottom: 0;
    margin-bottom: 0;
  }
}
</style>
